export const FACE_ID_PROFILE_REMARKS_MAX_LENGTH = 2500;
export const FACE_ID_PROFILE_FULL_NAME_MIN_LENGTH = 3;
export const FACE_ID_PROFILE_FULL_NAME_MAX_LENGTH = 250;
export const FACE_ID_PROFILE_DEPARTMENT_MAX_LENGTH = 200;
export const FACE_ID_PROFILE_EMPLOYEE_ID_LENGTH = 8;
export const FACE_ID_PROFILE_EMAIL_MAX_LENGTH = 254;
